import { EyeOutlined } from '@ant-design/icons';
import {
  Button,
  Form,
  Input,
  Modal,
} from 'antd';
import { patchSingleEjecucion } from 'api/pae/ejecuciones';
import FormSubmitControls from 'components/FormSubmitControls';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import styled from 'styled-components';
import { onError } from 'utils/handlers';
import { capitalize } from 'utils/normalizers';

const StyledButton = styled(Button)`
  display: flex;
  align-items: center;
  border: none;
  font-weight: 500;
`;

const StyledModal = styled(Modal)`
  .ant-modal-content {
    overflow: hidden;
  }
  
`;

export default function ModalObservaciones({
  setter,
  formItemName,
  remote,
  callback,
  ejecucionId,
  label,
  disabled,
}) {
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const onClose = () => {
    setOpen(false);
  };

  const onFinish = async () => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = form.getFieldsValue();
      if (!remote) {
        setter((prev) => ({ ...prev, [formItemName]: values.observaciones }));
        onClose();
      } else {
        await patchSingleEjecucion(ejecucionId, { [formItemName]: values.observaciones });
        callback(values.observaciones);
        onClose();
      }
    } catch (err) {
      onError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <StyledButton
        onClick={() => setOpen(true)}
        icon={<EyeOutlined />}
        disabled={disabled}
      >
        {label || 'Observaciones'}
      </StyledButton>

      <StyledModal
        open={open}
        closable={false}
        centered
        footer={null}
        width={600}
        title={(
          <FormSubmitControls
            onCancel={onClose}
            onFinish={onFinish}
            label={label}
            loading={loading}
          />
        )}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
        >
          <Form.Item
            name="observaciones"
            label="Observaciones"
            normalize={capitalize}
            rules={[{ required: true, message: 'Por favor, ingresa las observaciones' }]}
          >
            <Input.TextArea
              autoSize={{ minRows: 4, maxRows: 10 }}
              disabled={loading}
            />
          </Form.Item>
        </Form>
      </StyledModal>
    </>
  );
}

ModalObservaciones.propTypes = {
  setter: PropTypes.func.isRequired,
  formItemName: PropTypes.string.isRequired,
  remote: PropTypes.bool,
  callback: PropTypes.func,
  ejecucionId: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
};

ModalObservaciones.defaultProps = {
  remote: false,
  callback: () => {},
  ejecucionId: null,
  label: '',
  disabled: false,
};
